import {
    EquipmentTypeFragment,
    WarehouseEquipmentCategory,
} from '@control-tower/platform-wms';
import { EquipmentTypeDto } from '@pf/platform-wms/domain';
import { IconType } from '@pf/shared-common';

export type EquipmentGroup = 'LTL' | 'Parts' | 'Uniforms';

export const EquipmentGroupIcons: Record<
    EquipmentGroup,
    keyof typeof IconType
> = {
    LTL: 'ltl',
    Parts: 'parts',
    Uniforms: 'uniform',
};

export const LTL_EQUIPMENT_CATEGORIES: WarehouseEquipmentCategory[] = [
    WarehouseEquipmentCategory.Forklift,
    WarehouseEquipmentCategory.PalletJack,
];

export const PARTS_EQUIPMENT_CATEGORIES: WarehouseEquipmentCategory[] = [
    WarehouseEquipmentCategory.Cart,
    WarehouseEquipmentCategory.RollingCart,
];

export const EQUIPMENT_GROUPS: Record<
    EquipmentGroup,
    WarehouseEquipmentCategory[]
> = {
    LTL: LTL_EQUIPMENT_CATEGORIES,
    Parts: PARTS_EQUIPMENT_CATEGORIES,
    Uniforms: PARTS_EQUIPMENT_CATEGORIES,
};

export function canHandleGroup(
    group: EquipmentGroup,
    equipmentType?: EquipmentTypeFragment | EquipmentTypeDto | null
) {
    if (!equipmentType?.category) return false;
    return EQUIPMENT_GROUPS[group].includes(equipmentType.category);
}

export function isHandlingLtl(
    equipmentType?: EquipmentTypeFragment | EquipmentTypeDto | null
) {
    if (!equipmentType?.category) return false;
    return LTL_EQUIPMENT_CATEGORIES.includes(equipmentType.category);
}

export function isHandlingParts(
    equipmentType?: EquipmentTypeFragment | EquipmentTypeDto | null
) {
    if (!equipmentType?.category) return false;
    return PARTS_EQUIPMENT_CATEGORIES.includes(equipmentType.category);
}

export function isHandlingUniforms(
    equipmentType?: EquipmentTypeFragment | EquipmentTypeDto | null
) {
    // Uniforms uses the same equipment as Parts
    return isHandlingParts(equipmentType);
}
